<template>
  <div ref="container" >
    <a-modal :z-index="999" :title="title" width="90%" :visible="visible"
             :getContainer="() => $refs.container" :maskStyle="{'top':'93px','left':'154px','bottom':'200px'}"
             :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()" :maskClosable="false"
             @cancel="handleCancel" cancelText="关闭" style="top:20px;">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">关闭</a-button>
      </template>

      <a-table :columns="[{
          title: '追溯码清单',
          dataIndex: 'code',
          key: 'code',
        }]"  :data-source="paginatedData"
               bordered
               :pagination="pagination"
               @change="handleTableChange"
               style="padding: 0px 50px">
      </a-table>
      <div style="    position: absolute;  margin-top: -45px;  margin-left: 76px;">共计{{tableList.length}}个追溯码</div>

    </a-modal>
  </div>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JEllipsis from '@/components/jeecg/JEllipsis'
import { getLastDetail } from '@/api/api'
import { mixinDevice } from '@/utils/mixin'
export default {
  name: 'MaterialInOutList',
  mixins: [JeecgListMixin, mixinDevice],
  components: {
    JEllipsis,
  },
  data() {
    return {
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: false,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '30', '40'],
      },
      tableList:[],
      detail:{},
      loading: false,
      title: '详情',
      visible: false,
      disableMixinCreated: false,
      toFromType: '',
      currentMaterialId: '',
      dataSource: [],
      fileName: '',
      uuid: '',
      // 表头
      columns: [
        {
          "title": "产品名称",
          "dataIndex": "materialName"
        },
      ],
      labelCol: {
        xs: { span: 1 },
        sm: { span: 2 },
      },
      wrapperCol: {
        xs: { span: 10 },
        sm: { span: 16 },
      },
    }
  },
  created() {},
  computed: {
    paginatedData() {
      const start = (this.pagination.current - 1) * this.pagination.pageSize;
      const end = start + this.pagination.pageSize;
      return this.tableList.slice(start, end);
    },
  },
  methods: {

    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
    },
    async show(item,traceCode) {
      console.log('item,traceCode',item,traceCode)
      this.visible = true
      this.tableList = []
      const res = await getLastDetail({ code:traceCode})
      let tableList = []
      res.result.forEach(x=>{
        tableList.push({
          code:x
        })
      })
      this.tableList = tableList
      this.pagination.current = 1
      this.pagination.total = this.tableList.length;
    },
    handleCancel() {
      this.close()
    },
    close(){
      this.visible =false
    }
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
.lisenceTitle {
  display: block;
  font-size: 16x;
  margin: 30px 0 30px;
  padding-left: 10px;
  border-left: 4px solid #1890FF;
}
</style>
<style>
.ant-modal-content{
  margin-bottom: 200px;
}
</style>